<template>
  <div class="app-container">
    <div class="login-container">
      <pang-title :text="$router.lang.get('賬號 登入')" eng="Sign in" />
      <div class="login-form">
        <div class="input-container">
          <pang-input
            :placeholder="$router.lang.get('賬號')"
            ref="username"
            required
            v-model:value="username"
            name="username"
            :validate="usernameValidator"
            @enter="usernameEnter"
          />
        </div>
        <div class="input-container">
          <pang-input
            :placeholder="$router.lang.get('密碼')"
            ref="password"
            required
            v-model:value="password"
            name="password"
            type="password"
            :validate="passwordValidator"
            @enter="submit"
          />
        </div>
        <div class="button-container">
          <button class="submit" @click="submit()">
            {{ $router.lang.get("登入") }}
          </button>
        </div>
        <div class="checkbox-container">
          <input type="checkbox" v-model="remember" />
          <label @click="rememberChange">{{
            $router.lang.get("記住登入資訊")
          }}</label>
        </div>
      </div>
      <div class="link-container">
        <div>
          <pang-butt btype="plain" eventstr="signup_login">
            <div @click="goto('/account/register')">
              {{ $router.lang.get("會員註冊") }}
            </div>
          </pang-butt>
          <div @click="goto('/account/forgetaccount')">
            {{ $router.lang.get("查詢賬號") }}
          </div>
          <div @click="goto('/account/forgetpassword')">
            {{ $router.lang.get("查詢密碼") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useScreenState } from "../../store";
import { PangInput, PangTitle, PangButt } from "../../components";
import request from "../../api/request";
import validate from "../../utils/validate";
import { pwHash } from "../../utils";
import message from "../../utils/message";

export default {
  name: "Login",
  components: {
    PangInput,
    PangTitle,
    PangButt,
  },
  data() {
    const loginInfoStr = window.localStorage.getItem("loginInfo");
    let username = "";
    let password = "";
    let oldPass = null;
    let needHash = true;
    let remember = false;
    if (loginInfoStr) {
      const loginInfo = JSON.parse(loginInfoStr);
      username = loginInfo.username;
      password = loginInfo.password;
      oldPass = loginInfo.password;
      needHash = false;
      remember = true;
    }
    return {
      screenState: useScreenState(),
      username: username,
      password: password,
      remember: remember,
      needHash: needHash,
      oldPass: oldPass,
      usernameValidator: validate.usernameLogin,
      passwordValidator: validate.password,
      returnUrl: "/account",
    };
  },
  computed: {
    isCollapse() {
      return this.screenState.screenWidth < 900;
    },
  },
  methods: {
    submit() {
      let val1 = this.$refs.username.validateValue(this.username);
      let val2 = this.$refs.password.validateValue(this.password);
      if (val1 && val2) {
        if (this.password !== this.oldPass) {
          this.needHash = true;
        }
        if (this.needHash) {
          this.password = pwHash(this.password);
          this.needHash = false;
          this.oldPass = this.password;
        }
        let _this = this;
        if (!_this.remember) {
          window.localStorage.removeItem("loginInfo");
        }
        let username = this.username
        if (/^\d+$/.test(username))
            username = username.replace(/^0/, '')
        request.post(
            "/login",
            { username: username, password: this.password },
            this
          )
          .then(function (res) {
            if (res.status == 200) {
              if (_this.remember) {
                window.localStorage.setItem(
                  "loginInfo",
                  JSON.stringify({
                    username: _this.username,
                    password: _this.password,
                  })
                );
              }
              _this.screenState.token = res.data.data.tk;
              _this.screenState.user = res.data.user;
              window.localStorage.setItem("token", res.data.data.tk);
              window.localStorage.setItem(
                "user_info",
                JSON.stringify(res.data.user)
              );
              let url_list = _this.returnUrl.split('?')
              let params = {}
              if (url_list.length == 2) {
                let searchParams = new URLSearchParams(url_list[1]);
                 for(let key of searchParams.keys()) { 
                  params[key] = searchParams.get(key)
                }
              }
              _this.$router.replace({ path: _this.returnUrl, query: params});
            } else {
              message.resMessage(res, _this);
            }
          });
      }
    },
    rememberChange() {
      this.remember = !this.remember;
    },
    goto(href) {
      this.$router.push(href);
    },
    usernameEnter() {
      this.$refs.password.focus();
    },
  },
  beforeMount() {
    if (this.screenState.user) {
      if (window.localStorage.getItem('user_info'))
        this.$router.replace("/account");
      else
        this.screenState.user = null
    }
  },
  mounted() {
    if (this.$route.query.returnurl) {
      this.returnUrl = this.$route.query.returnurl;
    }
  },
};
</script>

<style scoped>
.login-container {
  height: 100%;
  color: #666666;
  padding-bottom: 44px;
}

.login-form {
  width: 90vw;
  max-width: 640px;
  margin: 48px auto;
}

.input-container {
  margin-bottom: 21px;
}

.button-container {
  margin-top: 30px;
}

.checkbox-container {
  margin-top: 27px;
  display: flex;
}

.checkbox-container > label {
  cursor: pointer;
  line-height: 30px;
  height: 30px;
  display: inline-block;
  margin: 3px 20px;
}

.link-container {
  border-top: 1px solid #e7e8eb;
  border-bottom: 1px solid #e7e8eb;
  border-image: -webkit-linear-gradient(to left, #fff, #e7e8eb, #fff) 8 10 8;
  border-image: -moz-linear-gradient(to left, #fff, #e7e8eb, #fff) 8 10 8;
  border-image: linear-gradient(to left, #fff, #e7e8eb, #fff) 8 10 8;
  height: 95px;
}

.link-container > div {
  display: flex;
  margin: auto;
  margin-top: 23px;
  max-width: 640px;
}

.link-container > div > div {
  text-align: center;
  margin: auto;
  width: 33%;
  line-height: 35px;
  height: 35px;
  border-left: 1px solid #b4b4b4;
  cursor: pointer;
}

.link-container > div > div:first-child {
  border-left: none;
}
</style>